var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 3C11.2606 3.00007 13.2459 5.13798 14.2321 6.625C14.7997 7.48098 14.798 8.56932 14.2253 9.42188C13.2368 10.8932 11.2533 12.9999 7.99967 13C4.74626 12.9998 2.7635 10.8932 1.77506 9.42188C1.20229 8.56929 1.19961 7.481 1.76725 6.625C2.75335 5.13801 4.73869 3.00021 7.99967 3ZM7.99967 5C6.34297 5.00018 4.99967 6.34326 4.99967 8C4.99967 9.65674 6.34297 10.9998 7.99967 11C9.65652 11 10.9997 9.65685 10.9997 8C10.9997 6.34315 9.65652 5 7.99967 5Z",
    fill: "#8F8F8F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 1.5,
    fill: "#8F8F8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye-open.a77386afd917f63752ba8e881c7da477.svg";
export { ForwardRef as ReactComponent };